import ReadOnlyFieldsLayer from './ReadOnlyFieldsLayer.component';

export default ReadOnlyFieldsLayer;
